import { render, staticRenderFns } from "./ContractualItemValue.vue?vue&type=template&id=02059a26"
import script from "./ContractualItemValue.vue?vue&type=script&lang=js"
export * from "./ContractualItemValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports